import { Link, useLocation } from "react-router-dom";
import { MessageSquare, Receipt, PieChart, Settings, Download } from "lucide-react";
import { cn } from "@/lib/utils";
import logo from "@/assets/logo.png";
import { Badge } from "@/components/ui/badge";

const menuItems = [
  { title: "Chat", icon: MessageSquare, path: "/" },
  { title: "Receipts", icon: Receipt, path: "/receipts" },
  { title: "Summary", icon: PieChart, path: "/summary" },
  { title: "Settings", icon: Settings, path: "/settings" },
  { title: "Install App", icon: Download, path: "/install" },
];

export function Sidebar() {
  const location = useLocation();

  return (
    <aside className="hidden md:flex w-64 h-full bg-sidebar border-r border-sidebar-border flex-col overflow-y-auto">
      <div className="p-6 border-b border-sidebar-border">
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 rounded-xl flex items-center justify-center">
            <img src={logo} alt="Tax.GBT Logo" className="w-10 h-10" />
          </div>
          <div>
            <div className="flex items-center gap-2">
              <h1 className="text-lg font-bold text-sidebar-foreground">Tax.GBT</h1>
              <Badge variant="secondary" className="text-[10px] px-1.5 py-0">BETA</Badge>
            </div>
            <p className="text-xs text-muted-foreground">Your AI tax expert</p>
          </div>
        </div>
      </div>

      <nav className="flex-1 p-4 space-y-1">
        {menuItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={cn(
                "flex items-center gap-3 px-4 py-3 rounded-lg transition-all",
                isActive
                  ? "bg-sidebar-accent text-sidebar-accent-foreground font-medium"
                  : "text-sidebar-foreground hover:bg-sidebar-accent/50"
              )}
            >
              <item.icon className="w-5 h-5" />
              <span>{item.title}</span>
            </Link>
          );
        })}
      </nav>

      <div className="p-4 border-t border-sidebar-border">
        <div className="bg-gradient-subtle rounded-lg p-4">
          <p className="text-xs text-muted-foreground mb-2">💡 Pro Tip</p>
          <p className="text-sm text-foreground">
            You're basically donating money to CRA if you don't track expenses 💸 Upload receipts as you go!
          </p>
        </div>
      </div>
    </aside>
  );
}
